import { Box, Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { t } from "i18next"
import { getExaminationNameTranslation } from "pages/learning/pages/admin/pages/exams/pages/details/components/helpers/AttendeeStatus"
import React from "react"
import { StyledTableContainer } from "shared/styled/Global"

const ExamDetails = ({ match }) => {
  const columns = [
    {
      accessorKey: "customerName",
      header: t("global.customer", "Customer")
    },
    {
      accessorKey: "userName",
      header: t("global.user_name", "User Name")
    },
    {
      accessorKey: "userFullname",
      header: t("global.name", "Name")
    },
    {
      accessorKey: "examResultCount",
      header: t("global.number_of_results", "Number of Results")
    },
    {
      accessorKey: "passedExamResultCount",
      header: t("global.number_of_approved_results", "Number of aproved results")
    },
    {
      accessorFn: (row) => {
        return row.isAttendee ? t("global.yes", "Yes") : t("global.no", "No")
      },
      header: t("global.is_participants", "Is participants")
    }
  ]

  const [examResult, examFuncs] = useApi()
  React.useEffect(() => {
    examFuncs.get(apiEndpoints.systemadminlearning.getexamdetails.replace("{id}", match.params.id))

    return () => {
      examFuncs.leave()
    }
  }, [match, examFuncs])

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminLearning(),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box mb={2}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            {examResult.status === 1 && <LoadingTypography variant="h1" width="300px" />}
            {examResult.status === 2 && (
              <Typography variant="h1">{getExaminationNameTranslation(examResult.data.name, t)}</Typography>
            )}
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          rows={examResult.status === 2 && examResult.data.users}
          loadingState={examResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}
export default ExamDetails
